import './login.scss';

import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { useAtom } from 'jotai';
import { ChangeEvent, FC, useEffect, useState } from "react";
import InputMask from 'react-input-mask';
import { useNavigate, useParams } from 'react-router-dom';
import { accessToken } from '../../atoms/atom';
import imgHome from '../../images/logo.png';
import { FormService } from '../../services/FormService';
import { LoginService } from '../../services/LoginService';
import { FormDTO } from '../../types/FormDTO';
import { LoginDTO } from '../../types/LoginDTO';

const Login: FC = () => {
	const { id } = useParams<{ id: string }>();
	const [accessTokenAtom, setAccessToken] = useAtom(accessToken);
	const navigate = useNavigate();
	const [invalidLogin, setInvalidLogin] = useState(false);
	const [cpf, setCpf] = useState('');
	const [secondId, setSecondId] = useState('');
	const [form, setForm] = useState<FormDTO>();
	const service = new LoginService();
	const [loading, setLoading] = useState(true);
	const [loadingLogin, setLoadingLogin] = useState(false);
	const label = form?.secondId === 'MATRICULA'
		? "Matrícula"
		: form?.secondId === 'BIRTH_DATE'
			? "Data de Nascimento"
			: "Identificador";

	async function handleLogin() {
		setLoadingLogin(true);
		setInvalidLogin(false);
		try {
			const body = {
				username: cpf,
				password: secondId
			} as LoginDTO;
			const responseLogin = await service.autentica(body, id);
			if (responseLogin && responseLogin.data) {
				if (responseLogin.status === 403) {
					setInvalidLogin(true);
					setAccessToken('');
					localStorage.removeItem('access-token');
					return;
				}
				setAccessToken(responseLogin.data.accessToken);
				localStorage.setItem('access-token', responseLogin.data.accessToken);
				navigate(`/${id}/inicio`);
			} else {
				setInvalidLogin(true);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoadingLogin(false);
		}
	};

	const handleUser = (event: ChangeEvent<HTMLInputElement>) => {
		setCpf(event.target.value);
	}

	const handlePassword = (event: ChangeEvent<HTMLInputElement>) => {
		setSecondId(event.target.value);
	}

	useEffect(() => {
		if (accessTokenAtom && accessTokenAtom !== "") {
			navigate(`/${id}/inicio`);
		}
	}, [accessTokenAtom]);

	useEffect(() => {
		const load = async () => {
			const service = new FormService();
			const response = await service.getForm(id);
			if (response && response.data) {
				if (response.data.currentQuestion === 90) {
					navigate(`/${id}/fim`);
					return;
				}
				setForm(response.data);
			}
			setLoading(false);
		};
		load();
	}, [id]);

	return loading
		? <Box width={'100%'} height={'100vh'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
				<CircularProgress sx={{color: "#0075b5ff"}} size={'50px'}/>
			</Box>
		: form && form.active
			? loginPage()
			: notFound();

	function loginPage() {
		return (
			<Box className="login-container">
				<Box className="login-card">
					<Box className="login-content">
						<img
							src={imgHome}
							alt="Logo da Empresa"
							className="company-logo"
						/>
						<InputMask mask="999.999.999-99"
							value={cpf}
							onChange={handleUser}
						>
							{(inputProps: any) => (
								<TextField
									{...inputProps}
									fullWidth
									margin="normal"
									label={"CPF"}
									variant="outlined"
									InputLabelProps={{ style: { color: "#535353ff" } }}
								/>
							)}
						</InputMask>
						{label === 'Data de Nascimento' ? (
							<InputMask
								mask="99/99/9999"
								value={secondId}
								onChange={handlePassword}
							>
								{(inputProps: any) => (
									<TextField
										{...inputProps}
										fullWidth
										margin="normal"
										label={label}
										variant="outlined"
										InputLabelProps={{ style: { color: "#535353ff" } }}
									/>
								)}
							</InputMask>
						) : (
							<TextField
								value={secondId}
								onChange={handlePassword}
								fullWidth
								margin="normal"
								label={label}
								variant="outlined"
								InputLabelProps={{ style: { color: "#535353ff" } }}
							/>
						)}
						{invalidLogin && (
							<Typography variant="body2" className="error-message">
								Dados inválidos.
							</Typography>
						)}
						<Button
							fullWidth
							variant="contained"
							color="primary"
							className="login-button"
							onClick={handleLogin}
							disabled={!cpf || !secondId || cpf.length < 14}
						>
							{loadingLogin ? <CircularProgress sx={{color: "#48a7dbff"}} size={'25px'}/> : "Login"}
						</Button>
					</Box>
				</Box>
			</Box>
		);
	}

	function notFound() {
		return (
			<div className="login-error">
				<Typography variant='h4'>Formulário indisponível</Typography>
			</div>
		);
	}
}

export default Login;